import ProductsActionCreators from "@/Actions/Products";
import EditOrCloneProductDrawer from "@/Components/ProductsPage/Drawers/EditOrCloneProductDrawer";
import useDispatch from "@/Components/Utils/useDispatch";
import { GlobalState } from "@/Reducers/interface";
import { EditOrCloneProductDrawerMode } from "@/Contracts/Products";
import ZAlert from "@atoms/ZAlert";
import ZTypography from "@atoms/ZTypography";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IProductUOMWarning } from "./interface";
import { ProductSource } from "@/Contracts/Products";

const { ZText, ZLink } = ZTypography;

const ProductUOMWarning: React.FC<IProductUOMWarning> = props => {
	const dispatch = useDispatch();

	const [visible, setVisible] = useState(false);

	const openDrawer = () => {
		setVisible(true);
		dispatch(ProductsActionCreators.editProductDrawerOpened());
	};

	const closeDrawer = () => {
		setVisible(false);
		dispatch(ProductsActionCreators.editProductDrawerClosed());
	};

	const { currentActiveProduct, connectwiseIntegration } = useSelector(
		(state: GlobalState) => {
			return {
				currentActiveProduct: state.products.currentActiveProduct,
				connectwiseIntegration:
					state.user.userCompany.integrations.connectwise
			};
		}
	);

	useEffect(() => {
		try {
			if (
				props.parentProductId &&
				shouldShowAlert &&
				!props.parentProductId.includes(ProductSource.Etilize) &&
				!props.parentProductId.includes(ProductSource.Icecat) &&
				!props.parentProductId.includes("dell-quote-import") &&
				!props.parentProductId.includes(ProductSource.Amazon)
			)
				dispatch(
					ProductsActionCreators.getProductDetails(
						props.parentProductId,
						props.productSource
					)
				);
		} catch (err) {
			console.error(err);
		}
		return () => {
			dispatch(ProductsActionCreators.resetProductDetails());
		};
	}, []);

	const shouldShowAlert =
		currentActiveProduct &&
		props.currentUOM !== currentActiveProduct?.unit_of_measure &&
		connectwiseIntegration;

	return shouldShowAlert ? (
		<>
			<ZAlert
				message={
					<ZText>
						UOM won't be synced with CW until you change the UOM of
						the parent product. <br />
						<ZLink onClick={openDrawer}>Click here to change</ZLink>
					</ZText>
				}
				type="info"
				showIcon
			/>
			<EditOrCloneProductDrawer
				visible={visible}
				currentActiveProduct={currentActiveProduct}
				onDrawerClose={closeDrawer}
				mode={EditOrCloneProductDrawerMode.EDIT}
			/>
		</>
	) : (
		<></>
	);
};

export default ProductUOMWarning;
